






import { Component, Vue } from 'vue-property-decorator';
import SearchBar from '@/views/search/SearchBar.vue';
import OrderStore from '@/stores/order/order.store';
import { getModule } from 'vuex-module-decorators';
import { DeliveryMethodDto } from '@/api';
import { DateFormatter } from '@/util/DateFormatter';
import ShopStore from '@/stores/shop.store';

@Component({
  components: {SearchBar},
})
export default class HeaderActionSection extends Vue {
  private orderStore = getModule(OrderStore, this.$store);
  private shopStore = getModule(ShopStore, this.$store);
  private methods = DeliveryMethodDto;

  private minutesUntilDeadline = 0;
  private timerId?: number;

  get deliveryType(): string | null {
    if (this.isMethodSelected(DeliveryMethodDto.PICKUP)) {
      return 'pickUp';
    } else if (this.isMethodSelected(DeliveryMethodDto.DELIVERY)) {
      return 'delivery';
    } else {
      return null;
    }
  }

  get selectedDeliverySlot() {
    this.resetTimer();
    return this.orderStore.currentDeliverySlot;
  }

  get pickupLocation(): string {
    if (this.isMethodSelected(DeliveryMethodDto.PICKUP)) {
      return '6511';
    } else if (this.orderStore.currentDeliveryAddress) {
      return this.orderStore.currentDeliveryAddress.postCode;
    } else {
      return '';
    }
  }

  get timeSlot() {
    if (this.selectedDeliverySlot) {
      return DateFormatter.formatShortDate(new Date(this.selectedDeliverySlot.startTime).toDateString()) +
        ', ' + DateFormatter.formatTime(this.selectedDeliverySlot.startTime) + ' - '
        + DateFormatter.formatTime(this.selectedDeliverySlot.endTime);
    }
    return '';
  }

  get deadlineDateFormatted() {
    if (this.selectedDeliverySlot) {
      return DateFormatter.formatShortDate(new Date(this.selectedDeliverySlot.orderDeadline).toDateString()) +
        ', ' + DateFormatter.formatTime(this.selectedDeliverySlot.orderDeadline);
    }
    return '';
  }

  get calculatedMinutesTillDeadline() {
    if (this.selectedDeliverySlot) {
      if (!this.timerId) {
        this.calculateMinutesUntilDeadline();
        this.timerId = window.setInterval(this.calculateMinutesUntilDeadline, 10000);
      }

      if (this.minutesUntilDeadline <= 0) {
        this.resetTimer();
        this.orderStore.resetDeliverySlot();
      }
    }

    return this.minutesUntilDeadline;
  }

  private resetTimer() {
    window.clearInterval(this.timerId);
    this.timerId = undefined;
    this.minutesUntilDeadline = 0;
  }

  get deadlineInfoThreshold(): number {
    return this.shopStore.deliveryDeadlineInfoThreshold;
  }

  get availableMethods(): DeliveryMethodDto[] {
    return this.shopStore.deliveryMethods;
  }

  get hasDeliveryChoice(): boolean {
    return this.availableMethods.length > 1;
  }

  public isMethodAvailable(method: DeliveryMethodDto): boolean {
    return this.availableMethods.some((available) => available === method);
  }

  public isMethodSelected(method: DeliveryMethodDto): boolean {
    return this.isMethodAvailable(method) && this.orderStore.currentDeliveryMethod === method;
  }

  get deadlineIsUnderThreshold(): boolean {
    return this.calculatedMinutesTillDeadline <= this.deadlineInfoThreshold;
  }

  private calculateMinutesUntilDeadline() {
    if (this.selectedDeliverySlot) {
      const diffMs = new Date(this.selectedDeliverySlot?.orderDeadline).valueOf() - new Date().valueOf();
      this.minutesUntilDeadline = Math.round((diffMs / 1000) / 60);
    }
  }
}
